import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { presetsAPI } from "../api/api";
import { PresetsActionTypes } from "../actions/actionTypes";

function* getGames() {
    try {
        const gamesResponse = yield call(() =>
            presetsAPI.getGames()
        );

        yield put({
            type: PresetsActionTypes.GET_GAMES_SUCCESS,
            payload: {
                games: gamesResponse.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting games list.");

        yield put({
            type: PresetsActionTypes.GET_GAMES_FAIL,
            message: e.message
        });
    }
}

export function* getGamesWatcher() {
    yield takeLatest(PresetsActionTypes.GET_GAMES, getGames);
}

